import React, {useState, useEffect} from "react";
import {useStore} from "../../../hooks/useStore";
import {InfoInput} from "./polyMapStyles";

const InfoWindowInput = ({inputValue, setInputValue, placeholder}) => {
    const store = useStore();

    useEffect(() => {
        setInputValue(placeholder);
    }, []);

    const onChangeHandler = event => {
        setInputValue(event.target.value);
    };

    return (
        <InfoInput
            type="text"
            name="name"
            data-testid="infoWindowInput"
            onChange={onChangeHandler}
            value={inputValue}
        />
    );
};

export default InfoWindowInput;
